import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MesaTrabajoView',
    name: 'MesaTrabajoView',
    component: () =>
      import(
        '../views/mesa-trabajo/MesaTrabajoView.vue'),
    meta: {
      title: 'Mesa de Trabajo',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MesaTrabajoView'),
      bread: {
        path: [
          'Registros',
        ],
      },
    },
  },
];
